export const icons = {
  right: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.3535 8.29297L13.6464 9.00007L20.2929 15.6465L13.6464 22.293L14.3535 23.0001L21.7071 15.6465L14.3535 8.29297Z"
      />
      <path fillRule="evenodd" clipRule="evenodd" d="M9 15.1465L21 15.1465L21 16.1465L9 16.1465L9 15.1465Z" />
    </>
  ),
  left: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.6465 8.29297L16.3536 9.00007L9.70712 15.6465L16.3536 22.293L15.6465 23.0001L8.29291 15.6465L15.6465 8.29297Z"
      />
      <path fillRule="evenodd" clipRule="evenodd" d="M21 15.1465L9 15.1465L9 16.1465L21 16.1465L21 15.1465Z" />
    </>
  ),
  down: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.3536 12.3535L21.6465 11.6464L15 18.2928L8.35358 11.6464L7.64647 12.3535L15 19.707L22.3536 12.3535Z"
      />
    </>
  ),
  up: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.64642 17.6465L8.35353 18.3536L15 11.7072L21.6464 18.3536L22.3535 17.6465L15 10.293L7.64642 17.6465Z"
      />
    </>
  ),
};
